/**
 * Cache keys for the shared stale-while-revalidate store (`api/resourceCache`). They live in
 * this dependency-free module (not next to their owning hook) so one feature can reference another's
 * key WITHOUT importing that feature's hook — e.g. `useContacts` invalidating the groups list after a
 * contact delete must not drag `GroupApi` into the lightweight home-flow recipient picker that also
 * consumes `useContacts`.
 */

/** The account's contacts list — shared by every `useContacts` instance (#165). */
export const CONTACTS_CACHE_KEY = "contacts";

/** The account's groups list (with member contacts) — shared by every `useGroups` instance (#165). */
export const GROUPS_CACHE_KEY = "groups";

/** The account's transfers, flattened to files in canonical (fetched) order — every `useTransfers` (#165). */
export const TRANSFERS_CACHE_KEY = "transfers";

/** The account's full reminder list (the tab buckets derive from it) — every `useReminders` (#165). */
export const REMINDERS_CACHE_KEY = "reminders";
